export default __webpack_public_path__ + "static/media/reaverstance.f34bd076.png";